/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FriendsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABgElEQVR4nOWUvUoDQRDHU4mFYKOd1kEj2AoWtpFkZ+aEuRm1yHMIPoKK4EdtJwkBn0Cw8A1UBLHSLkbRIBZ+oOzlw8vFmN1oIy5Ms3szv/3/Z29SqX+zEGUcSMqGtGYDSA4AOO1VxKDuG5SqWQhnk8UN6i2QvreH3NkzD4C8RYkoe/F9ICl3Fm8EaslHwZNNMqRnbftkLekCIHnwUXDdTCSSCReAQb13BgDqcexmO61929CuFknRQ4Gux5JfckE4HQGA07ahnbeXahAsj7krAIWE/Mss82jrmaKWrOdRoBS9itvFzANAcpOw4AKAJ70KfauCZO0LK54Bddf+H8w8/CNAPr84Ureh27PU5iN4BJJTg7qZC8IpTxW62hug8V69GpRta7ETgJmHALXiA2n069AZYkhXvAH10bHlBjCa6QcQ2WU00xMwVygM9qUgmmWy4aSiXwCgnvw+AOXoU4HWvKcr9LIlCGcA5bwBuHIC5EnmXSH2W0RZssVNoFknwJ9YH+km0DXULzKEAAAAAElFTkSuQmCC)
 */
export const FriendsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3 5v-.75C3 3.56 3.56 3 4.25 3s1.24.56 1.33 1.25C6.12 8.65 9.46 12 13 12h1a8 8 0 0 1 8 8 2 2 0 0 1-2 2 .21.21 0 0 1-.2-.15 7.65 7.65 0 0 0-1.32-2.3c-.15-.2-.42-.06-.39.17l.25 2c.02.15-.1.28-.25.28H9a2 2 0 0 1-2-2v-2.22c0-1.57-.67-3.05-1.53-4.37A15.85 15.85 0 0 1 3 5Z"
        className={colorClass}
      />
    </svg>
  );
};
